// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-cop/css/font-cop.css
// module id = 666
// module chunks = 42